import "./CalculatedDataUploadSection.css";
import LoadingButton from "./LoadingButton";

const DatabaseUploadSection = ({
  fileRef,
  selectedFile,
  handleFileChange,
  uploadOptions,
  setUploadOptions,
  uploadCalculatedData,
  loading,
}) => {
  return (
    <>
      <div className="calculated-data-upload-section">
        <h3 className="calculated-data-upload-section__title">
          System database upload
        </h3>
        <div className="calculated-data-upload-section__upload-area">
          <input
            type="file"
            ref={fileRef}
            onChange={handleFileChange}
            className="calculated-data-upload-section__file-input"
            accept=".xlsx,.xls"
          />
          {selectedFile && (
            <div className="calculated-data-upload-section__file-preview">
              <img src="/preview-xlsx.png" alt="Excel file" />
              <div className="calculated-data-upload-section__file-name">
                {selectedFile.name}
              </div>
            </div>
          )}
        </div>

        <div className="calculated-data-upload-section__controls">
          <div className="calculated-data-upload-section__checkboxes">
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.processAndOrigin}
                onChange={(e) =>
                  setUploadOptions({
                    ...uploadOptions,
                    processAndOrigin: e.target.checked,
                  })
                }
              />
              Process + Process Origin
            </label>
          </div>
          <LoadingButton
            color="primary"
            variant="contained"
            className="calculated-data-upload-section__upload-button"
            onClick={uploadCalculatedData}
            loading={loading}
          >
            Upload
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

export default DatabaseUploadSection;
